"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * NOTE(alexandrawang1): manually pulled this icon from https://www.figma.com/design/NoAX7z4MTQcmV2R9cgWALf/%F0%9F%9A%9A-Fulfilled-by-Faire---25-Pilot-?node-id=13488-5494&t=4rZNw5OQKympXJjM-0
 * @optimized using svgo:^3.0.2
 */
export const Cards = createSVGIcon(
  <path
    d="M3.967 10.786a1.05 1.05 0 0 0 .744 1.283l4.131 1.106a.096.096 0 0 1 0 .186l-5.16 1.38a.447.447 0 0 1-.538-.313L1.02 6.488a.447.447 0 0 1 .313-.538l4.083-1.097c.068-.02.137.05.117.118l-1.556 5.805zm3.328-7.665 7.412 1.987a.407.407 0 0 1 .284.5l-1.978 7.381a.407.407 0 0 1-.5.284l-7.41-1.987a.407.407 0 0 1-.284-.5l1.977-7.372a.41.41 0 0 1 .5-.284zm3.143 3.103a.42.42 0 0 0-.519.294L9.586 7.74 8.363 7.41a.422.422 0 0 0-.226.812l1.224.333-.333 1.224v.088a.387.387 0 0 0 .294.43.43.43 0 0 0 .49-.215l.029-.078.333-1.224 1.224.333h.088a.387.387 0 0 0 .43-.294.43.43 0 0 0-.215-.49l-.078-.028-1.224-.333.333-1.224a.42.42 0 0 0-.294-.519"
    fill="currentColor"
    clipPath="url(#clip0_13488_5490)"
  />,
  "FaireSourceCards",
  {
    viewBox: "0 0 16 17",
    fill: "none",
    color: Core.icon.primary,
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
